<template>
  <div id="future-stage">
    <meta-data v-if="page && page.metaTitle"
               :key="page.metaTitle"
               :meta-title="page.metaTitle"
               :meta-description="page.metaDescription"
               :no-index="page.noIndex"/>
    <livestream/>
    <teaser :headlineId="'ckgw3nw822zvi0970xzbfkxth'" :textId="'ckguuwazyx8m80911vm00zlvv'"/>
    <event-guide/>
    <content-slider :id="'ckh3cohntgpyr0b77vvjbxwks'" :futureStage="true"></content-slider>
    <walls-io :primary-headline="'Social'" :secondary-headline="'Wall'" :wall-name-prop="'tomorrowisnow'"/>
  </div>
</template>

<script>
import MetaData from '../components/MetaData';
import Livestream from '../components/future-stage/Livestream';
import Teaser from '../components/future-stage/Teaser';
import EventGuide from '../components/future-stage/EventGuide';
import WallsIo from '../components/WallsIo';
import ContentSlider from '../components/ContentSlider';
import AppConst from '../config/app.const';
import Settings from '../config/settings';

export default {
  name: 'FutureStage',
  components: {
    WallsIo,
    EventGuide,
    Teaser,
    Livestream,
    ContentSlider,
    MetaData
  },
  data () {
    return {
      loading: false,
      load3d: false,
      page: {}
    };
  },
  methods: {
    async fetchPage () {
      await this.$store.dispatch(AppConst.FETCH_PATH_NAME, {
        path: 'data?query=page&slug=future',
        lifetime: Settings.LIFETIME_DEFAULT
      })
        .then(response => {
          this.page = response.pages[0];
        })
        .catch(() => {
          setTimeout(this.fetchPage, 3000);
        });
    }
  },
  watch: {
    $route () {
      this.fetchPage();
    }
  },
  created () {
    this.fetchPage();
  }
};
</script>
